import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="home-blocks"
export default class extends Controller {
  connect() {
    const navbar = $('.navbar-base')
    navbar.css('box-shadow', '0 0 15px rgba(0, 0, 0, 0.09)')
    navbar.hide()

    function navbarAnimation() {
      const position = Math.floor($('#stepsBlock').offset().top)
      const scroll = $(window).scrollTop()
      if (scroll + 215 > position) {
        navbar.fadeIn(225)
        navbar.addClass('top-0')
      } else {
        navbar.fadeOut(225)
      }
    }

    function stepsAnimation() {
      const scrollPosition = $(window).scrollTop()
      const firstStep = $('#step1')
      const ndStep = $('#step2')
      const lastStep = $('#step3')

      if (scrollPosition < firstStep.offset().top) {
        $('a[href$="#step2"] li').addClass('disabled')
        $('a[href$="#step3"] li').addClass('disabled')
        $('a[href$="#step1"] li').removeClass('disabled')
      } else if (scrollPosition > ndStep.offset().top - 300 && scrollPosition < lastStep.offset().top - 400) {
        $('a[href$="#step1"] li').addClass('disabled')
        $('a[href$="#step3"] li').addClass('disabled')
        $('a[href$="#step2"] li').removeClass('disabled')
      } else if (scrollPosition > lastStep.offset().top - 400) {
        $('a[href$="#step2"] li').addClass('disabled')
        $('a[href$="#step2"] li').addClass('disabled')
        $('a[href$="#step3"] li').removeClass('disabled')
      }
    }

    function initAnchorsAnimation() {
      $("a[href^='#']").click(function (e) {
        e.preventDefault()
        const id = $(this).attr('href')
        if (id === '#') return
        $('html,body').animate({ scrollTop: $(id).offset().top - (navbar.height() + 30) }, 500)
      })
    }

    function parallaxEffect() {
      const windowScrolled = $(window).scrollTop()
      const sliderScrolled = $('.homepage-sliderblock').offset().top
      const quotationScrolled = $('.homepage-quotationblock').offset().top
      const accompanimentScrolled = $('.homepage-accompanimentblock').offset().top

      $('.top-block-right').css('top', 0 - windowScrolled * 0.25 + 'px')
      $('#block-left-specialite1').css('top', 0 - (windowScrolled - sliderScrolled) * 0.15 + 'px')
      $('#block-left-specialite2').css('top', 100 - (windowScrolled - sliderScrolled) * 0.25 + 'px')
      $('#block-left-specialite3').css('top', 0 - (windowScrolled - sliderScrolled) * 0.25 + 'px')
      $('#block-left-specialite4').css('top', 155 - (windowScrolled - sliderScrolled) * 0.35 + 'px')
      $('.quotation-right-block').css('top', 0 - (windowScrolled - quotationScrolled) * 0.2 + 'px')
      $('.accompaniment-left-block').css('top', 0 - (windowScrolled - accompanimentScrolled) * 0.2 + 'px')
    }

    function revealIcons() {
      const scrollPosition = $(window).scrollTop()
      const reassurancePosition = $('.homepage-reassuranceblock').offset().top

      if (scrollPosition > reassurancePosition - 300) {
        $('.reassurance-icons-wrapper').fadeTo(450, 1)
      }
    }

    initAnchorsAnimation()

    $(window).scroll(() => {
      navbarAnimation()
      stepsAnimation()
      parallaxEffect()
      revealIcons()
    })
  }
}
